export const CreditErrors = {
  MustNotExceedCreditLimit:
    "Total credit balance cannot exceed the max limit per user",
  MustBePositive: "This type of credit transaction must be positive",
  MustBeNegative: "This type of credit transaction must be negative",
  MustSettleImmediately:
    "This type of credit transaction must be settled immediately",
  PurchaseMustHaveOrderSlug: "Purchase transactions must have an order-slug-id",
  DepositMustHaveOrderSlug: "Deposit transactions must have an order-slug-id",
  MustNotHaveOrderSlug: "Transaction cannot have an order-slug-id",
  MustBeBelowOpenToBuy: "Transaction amount must be below open_to_buy",
  MustHaveFundSourceForRefund:
    "Refund transactions must specify whether the purchase was made in cash",
  MustHaveAdjustmentExpiration:
    "Must specify an expiration for positive adjustment credits",
  OnlyAdjustmentCanSpecifyExpiration:
    "A custom expiration can only be used for positive adjustment credits",
  TransactionMustIncludeUser: "Credit transaction must have an associated user",
  TransactionMustIncludeLearner:
    "This type of credit transaction must specify a learner",
  TransactionMustIncludeEsaMembership:
    "This type of credit transaction must have an associated Esa Membership",
  MustHaveAnActiveSubscription:
    "This type of credit account requires an active subscription",
  MustProvideCreditValueOrUidForSubscriptionAccount:
    "This type of credit account requires specifying a UID or credit value",
  MustNotHaveAnActiveSubscription:
    "This credit transaction is not allowed with an active subscription",
};

export const ESA_MEMBERSHIP_LOW_CREDIT = 20;
